// extracted by mini-css-extract-plugin
export var button = "_mv-2";
export var card = "_mv-0";
export var closeButtonContainer = "_mv-3";
export var iconContainer = "_mv-1";